export default "__VITE_ASSET__zLYDfEK7__"